(function() {
    'use strict';
    angular
        .module('moldovaYieldCurvesApp')
        .factory('CorporateCurvePointOpen', CorporateCurvePointOpen);

    CorporateCurvePointOpen.$inject = ['$resource', 'DateUtils'];

    function CorporateCurvePointOpen ($resource, DateUtils) {
        var resourceUrl =  'api/open/corporate-curve-points/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    return data;
                }
            }
        });
    }
})();
